import { ReactElement, useState } from 'react';
import { Link } from 'react-router';
import { Box, Card, CardActions, CardContent, CardMedia, Grid } from '@mui/material';
import { PlayCircle } from '@mui/icons-material';
import { ModalVideo } from '../ModalVideo';

// Styles
import styles from './Cta.module.scss';

export const Cta = (): ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoId, setVideoId] = useState('');

  const whatIsVideoId = '1118760743';
  const viewingVideoId = '1118760793';
  const findingVideoId = '1119110242';

  const whatIsVideoThumbnailUrl =
    'https://i.vimeocdn.com/video/2059047050-4e7155b9a6facb78e1655a72a4a5a519248cf95cb4bf50e1d0e6be01f75a37d9-d';
  const viewingVideoThumbnailUrl =
    'https://i.vimeocdn.com/video/2059497735-ee37dfbcd688aaa2856df3f90205d7c582d521fded6df872710c17522c268ba7-d';
  const findingVideoThumbnailUrl =
    'https://i.vimeocdn.com/video/2059497528-c568316b0df911660622c3c50c39d93c1eca12ac5b804686e4d073691b87f7ea-d';

  const handleModalOpen = (videoId: string, isOpen: boolean) => {
    setVideoId(videoId);
    setIsModalOpen(isOpen);
  };

  return (
    <>
      <div className={styles.backgroundContainer}>
        <div className={styles.container}>
          <h4>Welcome to CME Passport</h4>
          <h5>
            CME Passport is a free service for physicians, provided by the&nbsp;
            <Link to={'https://accme.org/'} target="_blank">
              Accreditation Council for Continuing Medical Education (ACCME)
            </Link>
            , the national accrediting authority for continuing medical education.
          </h5>

          <Grid container spacing={6}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ position: 'relative' }}>
              <Card className={styles.card} variant="outlined">
                <Box className={styles.overlayWrapper}>
                  <CardMedia
                    className={styles.image}
                    component="img"
                    image={whatIsVideoThumbnailUrl}
                    alt="What is CME Passport?"
                  />
                  <CardContent className={styles.overlay} onClick={() => handleModalOpen(whatIsVideoId, true)}>
                    <PlayCircle className={styles.playIcon} />
                  </CardContent>
                </Box>
                <CardActions className={styles.cardFooter}>
                  <h5>What is CME Passport?</h5>
                </CardActions>
              </Card>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Card className={styles.card} variant="outlined">
                <Box className={styles.overlayWrapper}>
                  <CardMedia
                    className={styles.image}
                    component="img"
                    image={viewingVideoThumbnailUrl}
                    alt="Viewing and Sharing Your CME Transcripts"
                  />
                  <CardContent className={styles.overlay} onClick={() => handleModalOpen(viewingVideoId, true)}>
                    <PlayCircle className={styles.playIcon} />
                  </CardContent>
                </Box>
                <CardActions className={styles.cardFooter}>
                  <h5>Viewing and Sharing Your CME Transcripts</h5>
                </CardActions>
              </Card>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Card className={styles.card} variant="outlined">
                <Box className={styles.overlayWrapper}>
                  <CardMedia
                    className={styles.image}
                    component="img"
                    image={findingVideoThumbnailUrl}
                    alt="Finding CME Activities and Meeting State Requirements"
                  />
                  <CardContent className={styles.overlay} onClick={() => handleModalOpen(findingVideoId, true)}>
                    <PlayCircle className={styles.playIcon} />
                  </CardContent>
                </Box>
                <CardActions className={styles.cardFooter}>
                  <h5>Finding CME Activities and Meeting State Requirements</h5>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </div>
      </div>

      <ModalVideo isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} videoId={videoId} autoplay muted={false} />
    </>
  );
};
